// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__Bisoy","addWidgetButton":"Header_addWidgetButton__uYUPI","dashboardTabs":"Header_dashboardTabs__bc-RP","active":"Header_active__3Izbn"};